import { GetDetailResponse, UpgradeResponse } from "@app/types";
import HttpService from "@core/services/http/http.service";
import { Signal } from "@core/services/http/http.type";

class _UpgradeService {
  public getUpgrade(signal?: Signal) {
    return HttpService.get<GetDetailResponse<UpgradeResponse>>(
      "/user/api/v1/services/premium",
      {
        signal,
      }
    );
  }
}

const UpgradeService = new _UpgradeService();

export default UpgradeService;
